const environment = process.env.NODE_ENV; // 'dev' or 'prod'

export const config = {
  apiUrl: environment === 'production'
    ? 'https://c3ctd0zmi7.execute-api.ap-southeast-2.amazonaws.com/prod'
    : 'https://x1rurbph46.execute-api.ap-southeast-2.amazonaws.com/dev'
};
